module.exports = __webpack_public_path__ + "static/media/mbna.35205114.svg";